/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import DefaultApiService from "../../../../../infrastructure/api/default";
import CustomMap from "../../../../components/map/CustomMap";
import { ModalTransition } from "../../../../components/shared/Dialog/Config";
import { colors } from "../../../../components/shared/chart";

const RequestMapDialog = ({ open, onClose, id }) => {
  const [data, setData] = useState({
    list: [],
    config: {
      center: [32.68, 51.68],
      zoom: 9,
      mapServiceKind: "Default",
    },
  });
  const [loading, setLoading] = useState(false);

  const onGetData = async (id) => {
    setLoading(true);
    const res = await DefaultApiService.getApi(
      `DG/Management/InProcessRequest/GetMapById`,
      { id }
    );
    // console.log("res", res);
    setLoading(false);
    setData(res.data);
  };

  const request = useMemo(
    () => (data?.list?.length > 0 ? data.list[0] : null),
    [data.list]
  );

  useEffect(() => {
    if (id) {
      onGetData(id);
    }
  }, [id]);

  if (!id || !request) return null;

  return (
    <Dialog
      open={open}
      TransitionComponent={ModalTransition}
      keepMounted
      maxWidth="lg"
      onClose={onClose}
      className="dialog-wrapper"
    >
      <DialogTitle>
        {`بررسی درخواست ${request?.request?.projectTitle || request?.name}`}
      </DialogTitle>

      <DialogContent sx={{}}>
        <Grid container>
          <Grid
            item
            xs={12}
            md={12}
            sx={{ position: "relative", minWidth: "50vw" }}
          >
            <CustomMap
              loading={loading}
              {...data.config}
              polygons={[
                {
                  positions: request.location,
                  color: colors[0],
                },
              ]}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions className="buttons-wrapper">
        <Button variant="outlined" size="large" onClick={onClose}>
          بستن
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RequestMapDialog;
